// extracted by mini-css-extract-plugin
module.exports = {"notification":"InlineNotification_notification__27EWZ","grey-bg":"InlineNotification_grey-bg__2dcZP","close-icon":"InlineNotification_close-icon__WpBfK"};